export default "__VITE_ASSET__nhk7vCm___"